<template>
  <div class="d-flex flex-column px-5 py-3 sidebar" :class="{ 'sidebar--hide': !isVisible }">
    <the-sidebar-header class="flex-grow-0" />
    <div style="overflow-y: auto; width: calc(100% + 20px); height: 100%" class="my-3">
      <keep-alive include="TheSidebarBody">
        <router-view name="sidebar" />
      </keep-alive>
    </div>
    <language-picker class="d-flex justify-end align-end flex-grow-1" />
    <v-btn icon small elevation="1" class="sidebar__button" @click="isVisible = !isVisible">
      <v-icon small> {{ isVisible ? 'mdi-chevron-right' : 'mdi-chevron-left' }} </v-icon>
    </v-btn>
  </div>
</template>

<script>
import { sync } from 'vuex-pathify';

import TheSidebarHeader from '@/components/sidebar/TheSidebarHeader';
import LanguagePicker from '@/components/shared/LanguagePicker';

export default {
  name: 'TheSidebar',
  components: { TheSidebarHeader, LanguagePicker },
  computed: {
    isVisible: sync('map/isSidebarVisible'),
  },
};
</script>

<style lang="scss" scoped>
.sidebar {
  background-image: url('~@/assets/images/sidebar-pattern.png');
  background-repeat: repeat;
  background-size: 500%;
  background-blend-mode: lighten;
  width: 467px;
  background-color: rgba(255, 255, 255, 0.98);
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
  transition: transform 0.5s;
  &--hide {
    transform: translateX(calc(100% - 19px));
  }
  &__button {
    background-color: #fff;
    border: 0.8px solid rgba(0, 0, 0, 0.2);
    position: absolute;
    top: 50%;
    left: 0;
    transform: translate(-50%, -50%);
  }
}
</style>
